<template>
  <div class="mx-auto w-full">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center pb-4">
        <b-select rounded v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="50">50 per page</option>
          <option value="100">100 per page</option>
          <option value="500">500 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>

        <vs-dropdown>
          <vs-button
            class="btn-drop"
            color="#5b3cc4"
            type="filled"
            icon="touch_app"
            >Column</vs-button
          >

          <vs-dropdown-menu>
            <vs-dropdown-group vs-label="Column">
              <vs-dropdown-item @click="showCol">Show/Hide</vs-dropdown-item>
            </vs-dropdown-group>
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-input
          placeholder="Search"
          v-model="searchval"
          @keydown.enter="goSearch"
        />

        <div v-if="colshow" class="mt-4">
          <div
            v-for="(column, index) in columnsTemplate"
            :key="index"
            class="control"
          >
            <b-checkbox v-model="column.visible">{{ column.title }}</b-checkbox>
          </div>
        </div>

        <b-table
          id="grid-table"
          class="w-full mt-4"
          :data="data"
          :loading="loading"
          :striped="isStriped"
          :narrowed="isNarrowed"
          :hoverable="isHoverable"
          :selected.sync="selected"
          paginated
          backend-pagination
          :total="total"
          :per-page="perPage"
          @page-change="onPageChange"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          backend-sorting
          :default-sort-direction="defaultSortOrder"
          :default-sort="[sortField, sortOrder]"
          @sort="onSort"
          :sticky-header="stickyHeaders"
          height="500px"
        >
          <template slot="bottom-left">
            <h3>Total : {{ total }}</h3>
          </template>

          <b-input
            class="w-full"
            slot="searchable"
            slot-scope="props"
            v-model="props.filters[props.column.field]"
            placeholder="Search..."
            size="is-small"
          />

          <template slot-scope="props">
            <b-table-column
              :field="columnsTemplate[0].field"
              :label="columnsTemplate[0].title"
              :visible="columnsTemplate[0].visible"
              sortable
              searchable
              >{{ props.row.inbfrom }}
            </b-table-column>

            <b-table-column
              :field="columnsTemplate[1].field"
              :label="columnsTemplate[1].title"
              :visible="columnsTemplate[1].visible"
              sortable
              searchable
              centered
            >
              <span
                :class="[
                  'tag',
                  { 'is-warning': props.row.status == 'OPEN' },
                  { 'is-danger': props.row.status == 'INBOUND_WAIT' },
                  { 'is-success': props.row.status == 'INBOUND_COMPLETE' },
                ]"
              >
                {{ props.row.status }}
              </span>
            </b-table-column>

            <b-table-column
              :field="columnsTemplate[2].field"
              :label="columnsTemplate[2].title"
              :visible="columnsTemplate[2].visible"
              sortable
              searchable
              >{{ props.row.skus_code }}
            </b-table-column>

            <b-table-column
              :field="columnsTemplate[3].field"
              :label="columnsTemplate[3].title"
              :visible="columnsTemplate[3].visible"
              sortable
              searchable
              centered
              >{{ props.row.dclnumber }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[4].field"
              :label="columnsTemplate[4].title"
              :visible="columnsTemplate[4].visible"
              sortable
              searchable
              centered
              >{{ cvDateNoTime(props.row.dcldate) }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[5].field"
              :label="columnsTemplate[5].title"
              :visible="columnsTemplate[5].visible"
              sortable
              searchable
              centered
              >{{ props.row.invnum }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[6].field"
              :label="columnsTemplate[6].title"
              :visible="columnsTemplate[6].visible"
              sortable
              searchable
              centered
              >{{ props.row.inborders_number }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[7].field"
              :label="columnsTemplate[7].title"
              :visible="columnsTemplate[7].visible"
              sortable
              searchable
              centered
              >{{ props.row.itemnum }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[8].field"
              :label="columnsTemplate[8].title"
              :visible="columnsTemplate[8].visible"
              sortable
              searchable
              >{{ props.row.mawb }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[9].field"
              :label="columnsTemplate[9].title"
              :visible="columnsTemplate[9].visible"
              sortable
              searchable
              >{{ props.row.hawb }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[10].field"
              :label="columnsTemplate[10].title"
              :visible="columnsTemplate[10].visible"
              sortable
              searchable
              centered
              >{{ formatnumber(props.row.itempck) }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[11].field"
              :label="columnsTemplate[11].title"
              :visible="columnsTemplate[11].visible"
              sortable
              searchable
              centered
              >{{ props.row.packages_code }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[12].field"
              :label="columnsTemplate[12].title"
              :visible="columnsTemplate[12].visible"
              sortable
              searchable
              centered
              >{{ formatnumber(props.row.itemgw) }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[13].field"
              :label="columnsTemplate[13].title"
              :visible="columnsTemplate[13].visible"
              sortable
              searchable
              centered
              >{{ props.row.gwunit }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[14].field"
              :label="columnsTemplate[14].title"
              :visible="columnsTemplate[14].visible"
              sortable
              searchable
              >{{ props.row.edescription }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[15].field"
              :label="columnsTemplate[15].title"
              :visible="columnsTemplate[15].visible"
              sortable
              searchable
              centered
              >{{ props.row.tmotypes_code }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[16].field"
              :label="columnsTemplate[16].title"
              :visible="columnsTemplate[16].visible"
              sortable
              searchable
              centered
              >{{ props.row.dest }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[17].field"
              :label="columnsTemplate[17].title"
              :visible="columnsTemplate[17].visible"
              sortable
              searchable
              centered
              >{{ props.row.pod }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[18].field"
              :label="columnsTemplate[18].title"
              :visible="columnsTemplate[18].visible"
              sortable
              searchable
              centered
              >{{ props.row.remark }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[19].field"
              :label="columnsTemplate[19].title"
              :visible="columnsTemplate[19].visible"
              sortable
              searchable
              centered
              >{{ props.row.editor }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[20].field"
              :label="columnsTemplate[20].title"
              :visible="columnsTemplate[20].visible"
              sortable
              searchable
              centered
              >{{ props.row.created_at }}</b-table-column
            >
          </template>
        </b-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      data: [],
      colshow: false,
      selected: null,
      total: 0,
      loading: false,
      isStriped: false,
      isHoverable: true,
      isNarrowed: false,
      stickyHeaders: true,
      sortField: "itemnum",
      sortOrder: "asc",
      defaultSortOrder: "asc",
      page: 1,
      perPage: 50,
      searchval: "",
      columnsTemplate: [
        { title: "Mode", field: "inbfrom", visible: true },
        { title: "Status", field: "status", visible: true },
        { title: "SKU Number", field: "skus_code", visible: false },
        { title: "Declaration", field: "dclnumber", visible: true },
        { title: "Declaration Date", field: "dcldate", visible: true },
        { title: "Invoice", field: "invnum", visible: true },
        { title: "Inbound Number", field: "inborders_number", visible: false },
        { title: "ItemNumber", field: "itemnum", visible: false },
        { title: "MAWB", field: "mawb", visible: true },
        { title: "HAWB", field: "hawb", visible: true },
        { title: "Package", field: "itempck", visible: true },
        { title: "Package Unit", field: "packages_code", visible: true },
        { title: "G/W", field: "itemgw", visible: true },
        { title: "G/W Unit", field: "gwunit", visible: true },
        { title: "Description", field: "edescription", visible: true },
        { title: "ประเภท", field: "tmotypes_code", visible: true },
        { title: "ไปยัง", field: "dest", visible: false },
        { title: "ผ่านทาง", field: "pod", visible: false },
        { title: "Remark", field: "remark", visible: true },
        { title: "Editor", field: "editor", visible: false },
        { title: "Created_at", field: "created_at", visible: false },
      ],
      background: "#23d160 !important",
      color: "white !important",
    };
  },
  props: ["masrec","companyGroupsCode"],
  methods: {
    cvDateNoTime(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/");
      return dformat;
    },
    showCol() {
      if (this.colshow == true) {
        this.colshow = false;
      } else {
        this.colshow = true;
      }
    },
    async getData() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
      // console.log(this.fromDate);
      this.loading = true;

      try {
        if (token) {
          const formData = {
            sortField: this.sortField,
            sortOrder: this.sortOrder,
            page: this.page,
            perpage: this.perPage,
            searchval: this.searchval,
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/inbdetails/getInbdetailsToDOM`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (!response.data) {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data,
            });
          } else {
            this.loading = false;

            this.data = [];
            let currentTotal = response.data.total_results;
            if (response.data.total_results / this.perPage > 1000) {
              currentTotal = this.perPage * 1000;
            }
            this.total = currentTotal;

            response.data.data.forEach((item) => {
              this.data.push(item);
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/pages/login/");
      }
    },
    /*
     * Handle page-change event
     */
    onPageChange(page) {
      this.page = page;
      this.getData();
    },
    /*
     * Handle sort event
     */
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.getData();
    },
    /*
     * Type style in relation to the value
     */
    type(value) {
      const number = parseFloat(value);
      if (number < 6) {
        return "is-danger";
      } else if (number >= 6 && number < 8) {
        return "is-warning";
      } else if (number >= 8) {
        return "is-success";
      }
    },
    // Format Number
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    // Search
    goSearch() {
      // console.log(this.searchval);
      this.getData();
    },
  },
  mounted() {
    // console.log(this.fromDate);
    this.getData();
    // setTimeout(() => {
    //     this.selected = this.data[1];
    // }, 500);
  },
  computed: {
    rowSelected() {
      return this.selected;
    },
    perPageChanged() {
      return this.perPage;
    },
    dbchanged() {
      return this.$store.state.inbdetailsgrid;
    },
  },
  watch: {
    rowSelected: function () {
      // console.log(this.selected);
      this.$emit("recsel", this.selected.skus_code);
    },
    perPageChanged: function () {
      this.getData();
    },
    dbchanged: function () {
      // console.log("dbchanged");
      this.getData();
    },
  },
};
</script>

<style>
#grid-table td {
  white-space: nowrap;
}
.is-sticky-column-one {
  background: #23d160 !important;
  color: white !important;
}
.is-sticky-column-two {
  background: #167df0 !important;
  color: white !important;
}
</style>